module.exports = __webpack_public_path__ + "assets/media/lunch.67c3f62b.mp3";